<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">

  <path d="m10.02148,7.04102H1.97852c-.5752,0-1.04102-.46582-1.04102-1.04102s.46582-1.04102,1.04102-1.04102h8.04297c.5752,0,1.04102.46582,1.04102,1.04102s-.46582,1.04102-1.04102,1.04102Z" fill="var(--iconPrimary, #222)"/>
  
</svg>